import { render } from "./SidebarCollapserComponent.vue?vue&type=template&id=3ab91977&scoped=true&ts=true"
import script from "./SidebarCollapserComponent.vue?vue&type=script&lang=ts"
export * from "./SidebarCollapserComponent.vue?vue&type=script&lang=ts"

import "./SidebarCollapserComponent.vue?vue&type=style&index=0&id=3ab91977&scoped=true&lang=scss"
import "./SidebarCollapserComponent.vue?vue&type=style&index=1&id=3ab91977&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ab91977"]])

export default __exports__